import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    bienesPersonal: [],
  },

  getters: {
    getBienesPersonal: (state) => state.bienesPersonal,
  },

  mutations: {
    SET_BIENES_PERSONAL(state, bienesPersonal) {
      state.bienesPersonal = bienesPersonal;
    },
  },

  actions: {
    async fetchBienesPersonal({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/personal/${idPersonal}/bienes`)
        .then((response) => {
          commit('SET_BIENES_PERSONAL', response.data.data);
        });
    },

    async saveBienesPersonal(_, bienesPersonal) {
      await axios
        .post(`PoliciaCuadrantes/C3/personal/${bienesPersonal.fk_idPersonal}/bienes`, bienesPersonal);
    },

    async updateBienesPersonal(_, bienesPersonal) {
      await axios
        .put(`PoliciaCuadrantes/C3/personal/${bienesPersonal.fk_idPersonal}/bienes/${bienesPersonal.fk_idCatBien}`, bienesPersonal);
    },
  },
};
